import { useEffect } from 'react';
import { useMatches } from 'react-router';

interface MetaTag {
  title?: string;
  name?: string;
  property?: string;
  content?: string;
}

export interface MetaResolver {
  meta: MetaTag;
}

export function HeadManager() {
  const matches = useMatches();

  useEffect(() => {
    let title: string | undefined;
    const metas: MetaTag[] = [];

    for (const match of matches) {
      const meta =
        match.handle &&
        typeof match.handle === 'object' &&
        'meta' in match.handle
          ? (match.handle.meta as Record<string, any>)
          : undefined;
      if (!meta) continue;

      if (meta.title) title = meta.title;
      if (meta.meta) metas.push(...meta.meta);
    }

    if (title) document.title = title;

    document.querySelectorAll('meta[data-managed]').forEach((el) => {
      el.remove();
    });

    for (const m of metas ?? []) {
      const el = document.createElement('meta');
      if (m.name) el.setAttribute('name', m.name);
      if (m.property) el.setAttribute('property', m.property);
      if (m.content) el.setAttribute('content', m.content);
      el.setAttribute('data-managed', 'true');
      document.head.appendChild(el);
    }
  }, [matches]);

  return null;
}
